<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
          <h3 class="mb-0">
            {{ $t('message.edit') }} {{ $tc('message.prestation',1) }}
          </h3>
        </div>
      </div>

      <div class="">
        <b-form>
          <b-container>
            <p class="heading text-center">{{$t('message.infoGenerale')}}</p>

            <b-row>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="etablissement-group"
                    :label="$t('message.nomEtablissement')"
                    label-for="etablissement"
                >
                  <select id="etablissement" v-model="$v.form.etablissement_id.$model"
                          @change="clearErrorField('etablissement_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('categorie_id')" style="color:red">
                                    {{getErrorsField('categorie_id')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="nomPatient-group"
                    :label="$t('message.nomPatient')"
                    label-for="nomPatient"
                >
                  <select id="nomPatient" v-model="$v.form.dossier_medical_id.$model"
                          @change="clearErrorField('dossier_medical_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mPatients" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.dossier_medical_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('dossier_medical_id')" style="color:red">
                                    {{getErrorsField('dossier_medical_id')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="dateFacturation-group"
                    :label="$t('message.dateFacturation')"
                    label-for="dateFacturation">
                  <b-form-input
                      id="dateFacturation"
                      v-model="$v.form.date_facturation.$model"
                      :state="$v.form.date_facturation.$dirty ? !(errorshasField('date_facturation') || $v.form.date_facturation.$error) : null"
                      placeholder=""
                      type="date"
                      @focus="clearErrorField('date_facturation')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('date_facturation')">
                    {{ getErrorsField('date_facturation') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="$v.form.date_facturation.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!--              <b-col sm="12">-->
              <!--                <span  class="obligatoire">*</span>-->
              <!--                <b-form-group-->
              <!--                    id="totalHorsRemise-group"-->
              <!--                    :label="$t('message.totalHorsRemise')"-->
              <!--                    label-for="totalHorsRemise">-->
              <!--                  <b-form-input-->
              <!--                      id="totalHorsRemise"-->
              <!--                      v-model="$v.form.total_hors_remise.$model"-->
              <!--                      :state="$v.form.total_hors_remise.$dirty ? !(errorshasField('total_hors_remise') || $v.form.total_hors_remise.$error) : null"-->
              <!--                      placeholder=""-->
              <!--                      type="number"-->
              <!--                      step="0.01"-->
              <!--                      @focus="clearErrorField('total_hors_remise')"-->
              <!--                  ></b-form-input>-->

              <!--                  <b-form-invalid-feedback v-if="errorshasField('total_hors_remise')">-->
              <!--                    {{ getErrorsField('total_hors_remise') }}-->
              <!--                  </b-form-invalid-feedback>-->

              <!--                  <b-form-invalid-feedback v-if="$v.form.total_hors_remise.$error">-->
              <!--                    {{ $t('message.requiredField') }}-->
              <!--                  </b-form-invalid-feedback>-->
              <!--                </b-form-group>-->
              <!--              </b-col>-->

              <!--              <b-col sm="12">-->
              <!--                <span  class="obligatoire">*</span>-->
              <!--                <b-form-group-->
              <!--                    id="remise-group"-->
              <!--                    :label="$t('message.remise')"-->
              <!--                    label-for="remise">-->
              <!--                  <b-form-input-->
              <!--                      id="remise"-->
              <!--                      v-model="$v.form.remise.$model"-->
              <!--                      :state="$v.form.remise.$dirty ? !(errorshasField('remise') || $v.form.remise.$error) : null"-->
              <!--                      placeholder=""-->
              <!--                      type="number"-->
              <!--                      step="0.01"-->
              <!--                      @focus="clearErrorField('remise')"-->
              <!--                  ></b-form-input>-->

              <!--                  <b-form-invalid-feedback v-if="errorshasField('remise')">-->
              <!--                    {{ getErrorsField('remise') }}-->
              <!--                  </b-form-invalid-feedback>-->

              <!--                  <b-form-invalid-feedback v-if="$v.form.remise.$error">-->
              <!--                    {{ $t('message.requiredField') }}-->
              <!--                  </b-form-invalid-feedback>-->
              <!--                </b-form-group>-->
              <!--              </b-col>-->

              <!--              <b-col sm="12">-->
              <!--                <span  class="obligatoire">*</span>-->
              <!--                <b-form-group-->
              <!--                    id="totalAvecRemise-group"-->
              <!--                    :label="$t('message.totalAvecRemise')"-->
              <!--                    label-for="totalAvecRemise">-->
              <!--                  <b-form-input-->
              <!--                      id="totalAvecRemise"-->
              <!--                      :value="$v.form.total_avec_remise.$model = form.total_hors_remise - form.remise"-->
              <!--                      type="number"-->
              <!--                      disabled-->
              <!--                      @focus="clearErrorField('total_avec_remise')"-->
              <!--                  ></b-form-input>-->

              <!--                  <b-form-invalid-feedback v-if="errorshasField('total_avec_remise')">-->
              <!--                    {{ getErrorsField('total_avec_remise') }}-->
              <!--                  </b-form-invalid-feedback>-->

              <!--                  <b-form-invalid-feedback v-if="$v.form.total_avec_remise.$error">-->
              <!--                    {{ $t('message.requiredField') }}-->
              <!--                  </b-form-invalid-feedback>-->
              <!--                </b-form-group>-->
              <!--              </b-col>-->
              <div v-if="hasGestionnaireRole || hasMedecinControleRole || hasAdminRole || hasAssistante">
                <b-col sm="12" >
                  <span  class="obligatoire">*</span>
                  <b-form-group
                      id="statut-group"
                      :label="$t('message.status')"
                      label-for="nomPatient"
                  >
                    <select id="statut" v-model="$v.form.statut.$model"
                            @change="clearErrorField('dossier_medical_id')"
                            class="form-control is-invalid retirerBordure"
                            required
                    >
                      <option data-placeholder="true"></option>
                      <option v-for="item in statuts" :key="item" :value="item">
                        {{ item }}
                      </option>
                    </select>
                    <b-form-invalid-feedback v-if="$v.form.statut.$error">
                      {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>
                    <span v-if="errorshasField('statut')" style="color:red">
                                    {{getErrorsField('statut')}}
                                    </span>
                  </b-form-group>
                </b-col>

                <b-col sm="12" v-if="form.statut == 'Rejeté'">
                  <span  class="obligatoire">*</span>
                  <b-form-group
                      id="motif-group"
                      :label="$tc('message.reasons',1)"
                      label-for="motif">
                    <b-form-textarea
                        id="motif"
                        v-model="$v.form.motif.$model"
                        @focus="clearErrorField('motif')"
                    ></b-form-textarea>

                    <b-form-invalid-feedback v-if="errorshasField('motif')">
                      {{ getErrorsField('motif') }}
                    </b-form-invalid-feedback>

                    <b-form-invalid-feedback v-if="$v.form.motif.$error">
                      {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </div>


            </b-row>
            <b-row>

            </b-row>
            <!--                        <b-row class="justify-content-sm-center" v-if="can && !continuer">-->
            <!--                            <b-button @click="validerForm" variant="primary">-->
            <!--                                {{ $t('message.continuer') }}-->
            <!--                            </b-button>-->
            <!--                        </b-row>-->

            <p class="heading text-center">{{$t('message.detailsFacture')}}</p>

            <b-row>
              <b-col sm="12" class="mb-3">
                <b-row >
                  <b-col sm="4">
                    <span class="consultation-item__title">{{$t('message.nomPrestation')}}</span>
                  </b-col>
                  <b-col  sm="2">
                    <span class="consultation-item__title">{{$t('message.price')}}</span>
                  </b-col>
                  <b-col sm="2">
                    <span class="consultation-item__title">{{$t('message.remise')}}</span></b-col>
                  <b-col sm="4">
                    <span class="consultation-item__title">{{$tc('message.actions',1)}}</span>
                  </b-col>
                </b-row>
                <b-row v-for="(prestation,index) in form.prestation" :key="index">
                  <b-col sm="4">{{getPrestation(prestation.prestation_id).nom}}</b-col>
                  <b-col sm="2">{{getPrestation(prestation.prestation_id).prix}}</b-col>
                  <b-col sm="2" >{{getPrestation(prestation.prestation_id).reduction}}</b-col>
                  <b-col sm="4" class="mb-2">
                    <b-button class="btn-sm " @click="validerPrestation(prestation.prestation_id)" variant="primary">
                      Validé
                    </b-button>

                    <b-button class="btn-sm" @click="showModal(prestation.prestation_id)" variant="dark">
                      Rejété
                    </b-button>

                    <b-button class="btn-sm"  @click="retirerPrestation(prestation.prestation_id)" variant="danger">
                      {{ $t('message.delete') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-modal
                  id="rejeter-modal"
                  size="sm"
                  header-bg-variant="danger"
                  header-text-variant="light"
                  :title="nom"
                  hide-footer
              >
                <div class="d-block text-center">
                  <b-form-group
                      id="datePrestation2-group"
                      :label="$tc('message.reasons',1)"
                      label-for="datePrestation2">
                    <b-form-textarea
                        class="mb-2"
                        id="datePrestation2"
                        v-model="$v.editPrestation.motif.$model"
                        :state="$v.editPrestation.motif.$dirty ? !(errorshasField('motif') || $v.editPrestation.motif.$error) : null"
                        @focus="clearErrorField('motif')"
                    ></b-form-textarea>

                    <b-form-invalid-feedback v-if="$v.editPrestation.motif.$error">
                      {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>

                <div class="d-block float-right">
                  <b-button variant="danger"  @click="rejeterPrestation">
                    Rejété
                  </b-button>

                  <b-button variant="secondary" @click="$bvModal.hide('rejeter-modal')">
                    {{ $t('message.cancel') }}
                  </b-button>
                </div>
              </b-modal>
            </b-row>
            <b-row >
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="prestation2-group"
                    :label="$t('message.nomPrestation')"
                    label-for="prestation2"
                >
                  <select id="prestation2" v-model="$v.prestation.prestation_id.$model"
                          @change="clearErrorField('prestation_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mPrestations" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.prestation.prestation_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('prestation_id')" style="color:red">
                                       {{getErrorsField('prestation_id')}}
                                    </span>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="datePrestation-group"
                    :label="$t('message.datePrestation')"
                    label-for="datePrestation">
                  <b-form-input
                      id="datePrestation"
                      :value="$v.prestation.date_prestation.$model"
                      :state="$v.prestation.date_prestation.$dirty ? !(errorshasField('date_prestation') || $v.prestation.date_prestation.$error) : null"
                      type="date"
                      @focus="clearErrorField('date_prestation')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('date_prestation')">
                    {{ getErrorsField('date_prestation') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="$v.prestation.date_prestation.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="justify-content-sm-center">
              <b-button @click="ajouterALaListe" variant="dark">
                {{ $t('message.ajouterDetail') }}
              </b-button>
              <b-button @click="onSubmit" variant="primary">
                {{ $t('message.modifierFacture') }}
              </b-button>
            </b-row>
          </b-container>


        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import moment from "moment";
import {required} from "vuelidate/lib/validators";
import SlimSelect from "slim-select";

export default {
  name: "Edit",

  computed: {
    ...mapGetters(['facture','hasAdminRole', "userInstitutions","errors",
      'hasGestionnaireRole', 'hasMedecinControleRole','isComptable','hasAssistante']),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
    },

    form:function(){
      let facture = this.facture;

      facture['prestation'] = facture.prestations;

      return facture;

    },

    mPrestations:function(){
      let pArray = [];
      let self = this;
      let etablissement = _.find(self.userInstitutions,function (institution) {
        return institution.id == self.form.etablissement_id;
      });
      if (!_.isUndefined(etablissement)) {
        let prestations = etablissement.prestations
        _.forEach(prestations, function (prestation) {
          //Ici nous allons conserver le nom des prestations et les identifiants de  prestation pour etablissement
          pArray.push({
            nom: prestation.prestation.nom,
            id: prestation.id,
            prix: prestation.prix,
            reduction: prestation.reduction
          });
        })
      }
      return pArray;
    },

    mPatients:function(){
      let pArray = [];
      let self = this;
      let etablissement = _.find(self.userInstitutions,function (institution) {
        return institution.id == self.form.etablissement_id;
      });
      if (!_.isUndefined(etablissement)){
        let patients = etablissement.patients;

        _.forEach(patients , function (patient) {
          let id = patient.dossier.id;
          let nom =patient.user.nom + ' ' + (_.isNull(patient.user.prenom) ? '' :patient.user.prenom);

          if (_.isUndefined(_.find(pArray, function (p) {
            return p.id == id;
          }))){
            pArray.push({nom:nom,id:id});
          }
        })
      }

      return  pArray;
    },

    mInstitutions:function () {
      let iArray = [];
      _.forEach(this.userInstitutions, function (institution) {
        iArray.push({nom:institution.name, id:institution.id});
      })
      return iArray;
    }
  },

  data(){
    return {
      // form : {},
      statuts:['Généré','Validé','Rejeté','Archivé','En recouvrement'],
      facture_id: this.$route.params.facture,
      continuer:false,
      prestationSelect:Object,
      nom:'',
      editPrestation:{
        motif:'',
        id:'',
        slug:'',
      },
      prestation:{
        date_prestation:moment((new Date())).format('YYYY-MM-DD'),
        prestation_id:null
      },
      total_avec_remise:0,
    }
  },

  watch:{

  },

  methods:{
    showModal(item){
      this.$bvModal.show('rejeter-modal');
      let prestation = _.find(this.form.prestation, function (prestation) {
        return prestation.prestation_id == item;
      })

      if(!_.isUndefined(prestation)){
        this.nom = this.getPrestation(item).nom;
        this.editPrestation.id = item;
        this.editPrestation.motif = prestation.motif ? prestation.motif : '';
        this.editPrestation.slug = prestation.slug;
      }

    },

    validerPrestation(item){
      let prestation = _.find(this.form.prestation, function (prestation) {
        return prestation.prestation_id == item;
      })
      if(!_.isUndefined(prestation)){
        let args = {};
        args.facture = prestation.slug;

        let successMessage = this.$i18n.t('message.prestationValide');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('validerFacturePrestation', { args, errorMessages, successMessage })
      }
    },

    rejeterPrestation(evt){
      evt.preventDefault();

      this.$v.editPrestation.$touch();

      if(!this.$v.editPrestation.$invalid) {
        let args = {};
        args.facture = this.editPrestation.slug;
        args.motif = this.editPrestation.motif

        let successMessage = this.$i18n.t('message.prestationRejete');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('rejeterFacturePrestation', { args, errorMessages, successMessage })
        this.$bvModal.hide('rejeter-modal');
      }
    },

    formattedDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },

    getFacture() {
      let args = {
        facture: this.facture_id,
      };
      this.$store.dispatch("getFacture", {args});
    },

    onFactureClick(params){
      this.$router.push({ name: 'facture', params: { facture: params.row.slug } });
    },

    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', { args : args });
    },

    validerForm(evt){
      evt.preventDefault();

      this.$v.form.$touch();

      if(!this.$v.form.$invalid) {
        this.continuer = true;
      }
    },

    onSubmit: function(evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      if(!this.$v.form.$invalid) {
        let args = {
          facture:this.facture_id,
          dossier_medical_id:this.form.dossier_medical_id,
          etablissement_id:this.form.etablissement_id,
          total_hors_remise:''+this.form.total_hors_remise,
          total_avec_remise:''+this.form.total_avec_remise,
          date_facturation:this.form.date_facturation,
          motif:this.form.motif,
          statut:this.form.statut,
          remise:''+this.form.remise,
          prestation:this.form.prestation
        };

        let successMessage = this.$i18n.t('message.factureUpdated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('updateFacture', { args, errorMessages, successMessage })
      }
    },

    ajouterALaListe(){
      let args = {};
      if (this.prestation.prestation_id != null){
        args.prestation_id = this.prestation.prestation_id;
        args.date_prestation = this.prestation.date_prestation;
        args.facture_id = this.facture.id;

        let successMessage = this.$i18n.t('message.factureCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('createFacturePrestation', { args, errorMessages, successMessage })

      }
    },

    getPrestation(id){
      return _.find(this.mPrestations, function (prestation) {
        return prestation.id == id;
      })
    },

    retirerPrestation(id){
      let prestation = _.find(this.form.prestation, function (prestation) {
        return prestation.prestation_id == id;
      })
      if(!_.isUndefined(prestation)){
        let args = {};
        args.facture = prestation.slug;

        let successMessage = this.$i18n.t('message.prestationDeleted');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('deleteFacturePrestation', { args, errorMessages, successMessage })
      }
    },

    // updateForm(){
    //     let facture = this.facture;
    //
    //     facture['prestation'] = facture.prestations;
    //
    //     this.form = facture;
    //
    // },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },

    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });

      this.getErrorsField(field);
    },
  },

  validations() {
    return {

      form : {
        prestation:{},
        dossier_medical_id: {required},
        etablissement_id:{required},
        total_hors_remise:{required},
        total_avec_remise:{required},
        date_facturation:{required},
        motif:{},
        statut:{required},
        remise:{},
      },

      prestation:{
        date_prestation:{required},
        prestation_id:{required}
      },

      editPrestation:{
        motif:{required},
      },
    }
  },

  mounted() {
    this.getUserInstitutions();

    this.getFacture();

    // this.updateForm();

    var prestation =  new SlimSelect({
      select: '#prestation2',
      placeholder: 'Select prestation',
    });

    var etablissement = new SlimSelect({
      select: '#etablissement',
      placeholder: 'Select etablissement',
      limit: 1
    });

    var patient = new SlimSelect({
      select: '#nomPatient',
      placeholder: 'Select patient',
      limit: 1
    });

    new SlimSelect({
      select: '#statut',
      placeholder: 'Select statut',
      limit: 1
    });

    this.prestationSelect = prestation;
    etablissement.disable();
    patient.disable();
  }
}
</script>

<style scoped>

</style>
